import { logger } from '@polkadot/util';
export const l = /*#__PURE__*/ logger('api/util');
